import axios from "./axiosInstance";

const categoryAPI = {
  listing: (params) => axios.get(`categories`, { params }),
  details: (slug, params) => axios.get(`categories/${slug}`, { params }),
};

export default categoryAPI;
